<template>
  <div class="flex items-center gap-8 min-w-0">
    <BittsAvatar
      :user="avatarUser"
      :show-initials="true"
      size="x-small"
      class="shrink-0"
    />
    <span class="text-sm font-bold truncate min-w-0" :title="displayName">
      {{ displayName }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { BittsAvatar } from '@crossbeam/bitts';

import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import { McpUsageResponse } from '@/composables/mcp/useMcpUsage';
import { useTeamStore } from '@/stores';

type UserRow = NonNullable<McpUsageResponse>['users'][number];

const { params } = defineProps<{
  params: ICellRendererParams<UserRow>;
}>();

const { getAuthorizationByUserId } = useTeamStore();

const displayName = computed(() => params.data?.name ?? 'Unknown user');

const avatarUser = computed(() => {
  const userId = params.data?.user_id;
  const authUser = userId ? getAuthorizationByUserId(userId)?.user : undefined;
  return authUser ?? { first_name: displayName.value };
});
</script>
